import React, { Component, Fragment } from "react";
import axios from "../../containers/api";
import {Row, Card, CardBody, CardTitle, Button} from "reactstrap";
import { Colxx} from "../../components/common/CustomBootstrap";
import {Link} from "react-router-dom";
import DriverSearch from "../manage-drivers/DriverSearch/DriverSearch";
import {Table} from "../../components/table/Table";
export default class AdminMain extends Component {
    constructor(props) {
        super(props);

        this.state = {
            AdminStatistics: null,
            driverResult:[],
            latitude: null,
            longitude: null,

        }
    }

    componentDidMount() {
        //this.GetAllDrivers();
        //this.getUserLocation()
        this.GetAdminShortStatistics()
    }
    
    getUserLocation = () => {
        // if geolocation is supported by the users browser
        if (navigator.geolocation) {
          // get the current users location
          navigator.geolocation.getCurrentPosition(
            (position) => {
              // save the geolocation coordinates in two variables
              //const { latitude, longitude } = position.coords;
              // update the value of userlocation variable
              //setUserLocation({ latitude, longitude });
              this.setState({ 
                latitude: position.coords.latitude, 
                longitude: position.coords.longitude
              })
              console.log("Location ::("+position.coords.latitude+","+position.coords.longitude+")");
            },
            // if there was an error getting the users location
            (error) => {
              console.error('Error getting user location:', error);
            }
          );
          //console.log("location: "+this.latitude +this.longitude);
        }
        // if geolocation is not supported by the users browser
        else {
          console.error('Geolocation is not supported by this browser.');
        }
      };
    GetAdminShortStatistics = () => {
        this.props.showSpinner();
        axios.get('api/v1/Cargos/GetStatisticalInformation')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({AdminStatistics: res.data.data})
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
            });
    };
    GetAllDrivers = () => {
        this.props.showSpinner();
       let url='api/v1/drivers/GetAllDriverInfo';
        axios.get(url)
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data === null || res.data.data.length === 0) {
                    this.props.showAlert("اطلاعات مورد نظر یافت نشد", "warning");
                } else {
                    this.setState({driverResult: res.data.data});
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(error, "error");
            });
    };
    render() {

        return (
            <Fragment>
                <DriverSearch
                    showSpinner={this.props.showSpinner}
                    hideSpinner={this.props.hideSpinner}
                    showAlert={this.props.showAlert}
                    showSweetAlert={this.props.showSweetAlert}
                    closeSweetAlert={this.props.closeSweetAlert}
                />
                {/* <Row>
                    <Colxx xxs="12" className="mb-4">
                        <Card>
                            <CardBody>
                                <CardTitle>لیست رانندگان ثبت نام شده</CardTitle>
                {this.state.driverResult !== null && this.state.driverResult.length > 0 ?
                                    <Table
                                        tableHeaders={[
                                            "شناسه",
                                            "نام کامل",
                                            "کد ملی",
                                            "موبایل",
                                            "هوشمند راننده",
                                           
                                            "تاریخ",
                                            "ساعت",

                                        ]}

                                        tableRow={this.state.driverResult}

                                        tableData={[
                                            x => {
                                                return x.id
                                            },
                                            x => {
                                                return x.name + " " + x.family
                                            },
                                            x => {
                                                return x.nationalId
                                            },
                                            x => {
                                                return x.mobile
                                            },
                                            x => {
                                                return x.cardNumber
                                            },
                                             
                                            x => {
                                                return x.registerDate;
                                            },
                                            x => {
                                                return x.registerTime;
                                            },
                                        ]}
                                    />
                                    :
                                    null
                                }
                                                            </CardBody>
                        </Card>
                    </Colxx>
                </Row> */}
                <Row className="mb-3">
                    <Colxx xl="4" lg="12">
                        <Card>
                            <CardBody className="d-flex flex-column justify-content-center align-items-center">
                            
                            {/* <Button color="primary" className="btn-lg mx-2" onClick={() => window.location.reload(true)}>
                                                    بروز رسانی پنل
                                                </Button> */}
                                <CardTitle>رانندگان</CardTitle>
                                <p>کل رانندگان ثبت نام شده</p>
                                <div className="dashboard-card-numbers">{this.state.AdminStatistics && this.state.AdminStatistics.driverCount}</div>
                            </CardBody>
                        </Card>
                    </Colxx>
                    <Colxx xl="4" lg="12">
                        <Card>
                            <CardBody className="d-flex flex-column justify-content-center align-items-center">
                                <CardTitle>اعلام بار</CardTitle>
                                <p> کل بارهای اعلام شده </p>
                                <div className="dashboard-card-numbers">{this.state.AdminStatistics && this.state.AdminStatistics.cargoCount}</div>
                            </CardBody>
                        </Card>
                    </Colxx>
                    <Colxx xl="4" lg="12">
                        <Card>
                            <CardBody className="d-flex flex-column justify-content-center align-items-center">
                                <CardTitle>رزرو بار</CardTitle>
                                <p>کل بار های رزرو شده</p>
                                <div className="dashboard-card-numbers">{this.state.AdminStatistics && this.state.AdminStatistics.reserveCount}</div>
                            </CardBody>
                        </Card>
                    </Colxx>
                    
                </Row>

                {/*<Row className="mb-3 management-row">*/}
                {/*    <Colxx xl="3" lg="12">*/}
                {/*        <Card>*/}
                {/*            <CardBody className="d-flex flex-column justify-content-center align-items-center">*/}
                {/*                <CardTitle>مدیریت نمایندگی‌ها</CardTitle>*/}
                {/*                <p>برای ورود سریع به صفحه مدیریت نمایندگی‌ها می‌توانید از دکمه زیر استفاده کنید.</p>*/}
                {/*                <div className="d-flex flex-md-row flex-column justify-content-center align-items-center">*/}
                {/*                    <Link to="/Admin/TransportationCompany" type="button">*/}
                {/*                        <Button outline color="primary" className="my-1 mx-1">*/}
                {/*                            مدیریت نمایندگی‌ها*/}
                {/*                        </Button>*/}
                {/*                    </Link>*/}
                {/*                    <Link to="/NewAgent" type="button">*/}
                {/*                        <Button outline color="primary" className="my-1 mx-1">*/}
                {/*                            نمایندگی جدید*/}
                {/*                        </Button>*/}
                {/*                    </Link>*/}
                {/*                </div>*/}
                {/*            </CardBody>*/}
                {/*        </Card>*/}
                {/*    </Colxx>*/}
                {/*    <Colxx xl="3" lg="12">*/}
                {/*        <Card>*/}
                {/*            <CardBody className="d-flex flex-column justify-content-center align-items-center">*/}
                {/*                <CardTitle>مدیریت مشتریان</CardTitle>*/}
                {/*                <p>برای ورود سریع به صفحه مدیریت مشتریان می‌توانید از دکمه زیر استفاده کنید.</p>*/}
                {/*                <div className="d-flex flex-md-row flex-column justify-content-center align-items-center">*/}
                {/*                    <Link to="/Admin/Customer" type="button">*/}
                {/*                        <Button outline color="secondary" className="my-1 mx-1">*/}
                {/*                            مدیریت مشتریان*/}
                {/*                        </Button>*/}
                {/*                    </Link>*/}
                {/*                    <Link to="/Admin/Customer/Add" type="button">*/}
                {/*                        <Button outline color="secondary" className="my-1 mx-1">*/}
                {/*                            مشتری جدید*/}
                {/*                        </Button>*/}
                {/*                    </Link>*/}
                {/*                </div>*/}
                {/*            </CardBody>*/}
                {/*        </Card>*/}
                {/*    </Colxx>*/}
                {/*    <Colxx xl="3" lg="12">*/}
                {/*        <Card>*/}
                {/*            <CardBody className="d-flex flex-column justify-content-center align-items-center">*/}
                {/*                <CardTitle>مدیریت رانندگان</CardTitle>*/}
                {/*                <p>برای ورود سریع به صفحه مدیریت رانندگان می‌توانید از دکمه زیر استفاده کنید.</p>*/}
                {/*                <Link to="/Admin/Driver/DriverSearch" type="button">*/}
                {/*                    <Button outline color="success" className="my-1">*/}
                {/*                        جستجوی راننده*/}
                {/*                    </Button>*/}
                {/*                </Link>*/}
                {/*            </CardBody>*/}
                {/*        </Card>*/}
                {/*    </Colxx>*/}
                {/*    <Colxx xl="3" lg="12">*/}
                {/*        <Card>*/}
                {/*            <CardBody className="d-flex flex-column justify-content-center align-items-center">*/}
                {/*                <CardTitle>مدیریت اعلام بارها</CardTitle>*/}
                {/*                <p>برای ورود سریع به صفحه مدیریت اعلام بارها می‌توانید از دکمه زیر استفاده کنید.</p>*/}
                {/*                <Link to="/Admin/Loads" type="button">*/}
                {/*                    <Button outline color="warning" className="my-1">*/}
                {/*                        لیست اعلام بارها*/}
                {/*                    </Button>*/}
                {/*                </Link>*/}
                {/*            </CardBody>*/}
                {/*        </Card>*/}
                {/*    </Colxx>*/}
                {/*</Row>*/}
            </Fragment>
        )
    }
}
